import React, { useEffect, useState } from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { ResponsiveImage, Modal } from '../../components';

import ImageCarousel from './ImageCarousel/ImageCarousel';
import ActionBarMaybe from './ActionBarMaybe';

import css from './ListingPage.module.css';

const SectionHero = props => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const {
    title,
    listing,
    isOwnListing,
    editParams,
    currentUser,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
    noPayoutDetailsSetWithOwnListing,
  } = props;

  const hasImages = listing.images && listing.images.length > 0;
  const imagesCount = listing.images && listing.images.length ? listing.images.length : 0;
  const firstImage = hasImages ? listing.images[0] : null;
  const secondImage = imagesCount >= 2 ? listing.images[1] : null;
  const thirdImage = imagesCount >= 3 ? listing.images[2] : null;
  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith('scaled'))
    : [];
  const variants2 = secondImage
    ? Object.keys(secondImage?.attributes?.variants).filter(k => k.startsWith('scaled'))
    : [];
  const variants3 = thirdImage
    ? Object.keys(thirdImage?.attributes?.variants).filter(k => k.startsWith('scaled'))
    : [];

  const viewPhotosButton = hasImages ? (
    <button className={css.viewPhotos} onClick={handleViewPhotosClick}>
      <FormattedMessage
        id="ListingPage.viewImagesButton"
        values={{ count: listing.images.length }}
      />
    </button>
  ) : null;

  const rightSideImage = imagesCount === 2 ? (
    <ResponsiveImage
      rootClassName={css.rootForSecondImage}
      alt={title}
      image={secondImage}
      variants={variants2}
    />
  ) : null;

  const rightSideImages = imagesCount > 2 ? (
    <div className={css.rightImagesSection}>
      <ResponsiveImage
        rootClassName={css.rootForRightFirstImage}
        alt={title}
        image={secondImage}
        variants={variants2}
      />
      <ResponsiveImage
        rootClassName={css.rootForRightSecondImage}
        alt={title}
        image={thirdImage}
        variants={variants3}
      />
    </div>
  ) : null;

  return (
    <section className={css.sectionHero} data-testid="hero">
      <div className={css.imageWrapperForSectionHero} onClick={handleViewPhotosClick}>
        {mounted && listing.id && isOwnListing ? (
          <div onClick={e => e.stopPropagation()} className={css.actionBarContainerForHeroLayout}>
            <ActionBarMaybe
              className={css.actionBarForHeroLayout}
              isOwnListing={isOwnListing}
              listing={listing}
              editParams={editParams}
              currentUser={currentUser}
            />
          </div>
        ) : null}

        <ResponsiveImage
          rootClassName={css.rootForImage}
          alt={title}
          image={firstImage}
          variants={variants}
        />
        {rightSideImage}
        {rightSideImages}
        {viewPhotosButton}
      </div>
      <Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ImageCarousel
          images={listing.images}
          imageVariants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
        />
      </Modal>
    </section>
  );
};

export default SectionHero;
